$("#addCompanyTypeBtn").on('click', function () {
    var div = $('#CompanyTypeDiv');

    $('input[name="CompanyType"]:checked').prop('checked', false);

    var url = window.location.href;
    var dilKodu = url.split('/')[3];

    var placeholder = "Sirket Tanimi Giriniz.";
    if (dilKodu === "en") {
        placeholder ="Enter Company Description."
    }


    var input = '<div id="CompanyTypeInputDiv"><br/><input type="text" class="form-control" name="CompanyType" placeholder="' + placeholder + '" /></div>';

    div.append(input);

    $(this).hide();
})

$('input[name="CompanyType"]').on('change', function () {

    var div = $('#CompanyTypeInputDiv');

    if (div != undefined) {
        div.remove();
        $("#addCompanyTypeBtn").show();
    }
});

$('input[name="HasCompanyText"]').on('change', function () {
    var displayStatus = $('#companyFormDiv').css("display");

    if (displayStatus == 'none') {
        $('input[name="CompanyType"]').eq(0).prop('checked', true);
        $("#companyFormDiv").show();
    } else {
        $('input[name="CompanyType"]:checked').prop('checked', false);
        $("#companyFormDiv").hide();

    }
});


function dosyaAdiniGoster(input) {
    var dosyaAdiSpan = document.getElementById("fileName");
    dosyaAdiSpan.innerText = input.files[0].name;
}


$('#dealerForm').on("submit", function (e) {

    e.preventDefault();

    var dosya = document.getElementById("dosya").files[0];

    var maksimumBoyut = 2 * 1024 * 1024; 
    if (dosya && dosya.size > maksimumBoyut) {
        alert("Dosya boyutu �ok b�y�k. En fazla 2MB dosya y�klenebilir.");
        return;
    }

    var formData = new FormData(this);

    $.ajax({
        url: "/DealerShipApplications/Create",
        method: "POST",
        data: formData,
        contentType: false,
        processData: false,
        success: function (result) {
            if (!result.success) {
                alert(result.message);
                return;
            }

            alert(result.message);

            window.location.href = "/";
        },
        error: function (xhr, status, error) {

            console.error(xhr.responseText);
        }
    });
})

$('.infoImg').click(function () {
    $('.infoPopup').toggleClass('gizli');
});